import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppClientConfigurationService, DialogService, AppServerAPI, Identity } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { Observable } from 'rxjs';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { LinkTransportsDialogComponent } from '../../../components/link-transports/component/link-transports-dialog.component';
import { LinkTransportDetails } from '../../../components/link-transports/link-transports.model';

@Component({
    selector: 'app-link-transport-dialog-action',
    templateUrl: './link-transport-dialog-action.component.html',
    styleUrls: ['./link-transport-dialog-action.component.scss'],
    standalone: false
})
export class LinkTransportDialogActionComponent {

  @Input() disabled = false;

  @Input() transportId: number;

  @Input() asButton = false;

  @Output() onChange = new EventEmitter<void>();

  TMCClientParameters = TMCClientParameters;

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private appServerAPI: AppServerAPI,
    public cps: AppClientConfigurationService
  ) {}

  public linkTransports() {

    if (this.disabled) {
      return;
    }


    this.loadLinkableTransports({ id: this.transportId }).subscribe(
      details => {
        const dialogRef = this.dialogService.openLarge(LinkTransportsDialogComponent, {
          details: details,
          autoFocus: false
        });
        dialogRef.afterClosed().subscribe(
          r => {
            this.onChange.next();
          }
        );
      },
      error => {
        // result.error('Error loading linkable transports');
      }
    );

  }

  private loadLinkableTransports(sourceTransport: Identity): Observable<LinkTransportDetails> {
    return this.appServerAPI.execute('/client/control/linktransports' + '', sourceTransport);
  }
}
